import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Scrollbars } from "react-custom-scrollbars";
import Aux from "../../../system/containers/Aux";
import Loading from "../../../system/components/Loading";
import PageHeader from "../../../system/components/PageHeader";
import FormWrapper from "../../../system/components/FormWrapper";
import FlexWrapper from "../../../system/components/FlexWrapper";
import EditSideColumn from "./components/EditSideColumn";
import { validateUser } from "../../../system/utils/UserPermissions";
import Form from "./Form";

import { actionCreators } from "../../../store/enquiries/holidays";
import { reducers as enquiriesHolidays } from "../../../store/enquiries/holidays/actions";

class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["VIEW_ENQUIRIES", "ALL"],
    };
  }

  // Submit function goes here.  Will be the PUT request of the model.
  submit = (values) => {
    const id = this.props.match.params.id;
    this.props.dispatch(actionCreators.update(id, values));
  };

  remove = () => {
    const confirm = window.confirm(
      "Are you sure you want to remove this entry?"
    );
    if (confirm) {
      const id = this.props.match.params.id;
      this.props.dispatch(actionCreators.delete([id]));
    }
  };

  componentWillMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
    this.props.dispatch(actionCreators.fetch(this.props.match.params.id));
  }

  render() {
    const { data, loading } = this.props;

    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title={"Edit Holiday Enquriy"} />
        <FlexWrapper>
          <FormWrapper>
            <Scrollbars>
              <Form
                onSubmit={this.submit}
                mode="edit"
                initialValues={data}
                enableReinitialize={true}
                {...this.props}
              />
            </Scrollbars>
          </FormWrapper>
          <EditSideColumn
            submit={this.submit}
            isLoading={loading}
            mode="edit"
            remove={this.remove}
            slug={""}
            created={data.created_at !== undefined ? data.created_at : ""}
          />
        </FlexWrapper>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.enquiriesHolidays.entry,
    loading: store.enquiriesHolidays.loading,
  };
}

export default withRouter(connect(mapStateToProps)(Edit));



// WEBPACK FOOTER //
// ./src/containers/Enquiries/HolidayEnquiry/Edit.jsx